import { Box, Button, makeStyles } from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { ProductStyles } from "../../../../common/sharedStyles";
import { useSatSteps } from "../../../../hooks";
import { Colors, SubtitleText, TitleText } from "../../../controls/helpers";
import { Body, Hero } from "../../GridLayout";
import QuestionnaireScreen from "../../QuestionnaireScreen";

const LifeCycle = () => {
  const { goToNextStep, currentStep } = useSatSteps();
  const isKs = currentStep.route.toLowerCase().indexOf("ks") !== -1;
  const classes = useStyles({ isKs });

  return (
    <QuestionnaireScreen overrideNextPageRoute={() => (isKs ? "kiwisaver-calculator" : "contribution-calculator")}>
      <Hero isNarrowView className={classes.hero}>
        <TitleText>{isKs ? "KiwiSaver" : "Wealth Builder"}</TitleText>
      </Hero>
      <Body isNarrowView>
        <Box>
          <TitleText>It looks like Life Cycle asset allocation is a great option for your {isKs ? "KiwiSaver" : "Wealth Builder"}.</TitleText>
          <SubtitleText hideMarginBottom>
            NZ Funds Life Cycle asset allocation automatically adjusts your savings across three Strategies based on your age, to help you to maximise your retirement savings.
          </SubtitleText>
          <Box py={5} textAlign="center">
            <SubtitleText>This asset allocation will be reviewed by your adviser or nominated representative.</SubtitleText>
            <Button onClick={(_) => goToNextStep(isKs ? "ks-asset-allocation-options" : "wb-asset-allocation-options")} variant="contained" endIcon={<ArrowForwardIcon />}>
              Learn about other allocation options
            </Button>
          </Box>
        </Box>
      </Body>
    </QuestionnaireScreen>
  );
};

const useStyles = makeStyles(
  {
    hero: ({ isKs }: { isKs: boolean }) => ({
      justifyContent: "flex-start !important",
      height: "144px !important",
      backgroundColor: `${isKs ? ProductStyles.KiwiSaver.color : ProductStyles.WealthBuilder.color} !important`,
      alignItems: "normal !important",
      padding: 24,
      "& h4": {
        color: `${Colors.White} !important`,
        lineHeight: 1,
      },
    }),
  },
  { name: "LifeCycle" }
);

export default LifeCycle;
